import React, { useEffect, useRef } from "react";
import "plyr/dist/plyr.css"; // Import Plyr styles
import Plyr from "plyr";
import Hls from "hls.js";

const HlsPalyer = ({ source }) => {
  const videoRef = useRef();

  // console.warn('source', source)

  function updateQuality(newQaulity) {
    window.hls.levels.forEach((level, levelIndex) => {
      if (level.height === newQaulity) {
        window.hls.currentLevel = levelIndex;
      }
    });
  }
  const handleContentLoaded = () => {
    // console.warn("call");
    var video = videoRef.current;
    // var source = source;

    const defaultOptions = {};

    if (Hls.isSupported()) {
      // console.warn("support");
      const hls = new Hls();
      hls.loadSource(source);
      hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
        const availableQualities = hls.levels.map((l) => l.height);
        defaultOptions.controls = [
          "play",
          "current-time",
          "progress",
          "duration",
          "fast-forward",
          "mute",
          "settings",
          "fullscreen",
        ];
        defaultOptions.quality = {
          default: availableQualities[0],
          options: availableQualities,
          forced: true,
          onChange: (e) => updateQuality(e),
        };
        new Plyr(video, defaultOptions);
      });
      hls.attachMedia(video);
      window.hls = hls;
    }
  };

  useEffect(() => {
    handleContentLoaded();
  }, []);
  return (
    <div>
      <video ref={videoRef}></video>
    </div>
  );
};

export default HlsPalyer;
